import styled from "styled-components";

import {
    VOTEBOX_COMPACT_TEXT_BUTTON_MIN_HEIGHT,
    VOTEBOX_FONT_SIZE_SMALL,
    VOTEBOX_FONT_WEIGHT_BOLD,
    VOTEBOX_SMALL_ICON_SIZE,
    VOTEBOX_TEXT_COLOR,
} from "../voteboxTokens";

export const StyledToggleButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    min-height: ${VOTEBOX_COMPACT_TEXT_BUTTON_MIN_HEIGHT};
    padding: 0;
    border: 0;
    background: none;
    color: ${VOTEBOX_TEXT_COLOR};
    font: inherit;
    font-weight: ${VOTEBOX_FONT_WEIGHT_BOLD};
    font-size: ${VOTEBOX_FONT_SIZE_SMALL};
    cursor: pointer;
    .MuiSvgIcon-root {
        font-size: ${VOTEBOX_SMALL_ICON_SIZE};
    }
`;
